import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { flushStore, hydrateStore } from './lib/storage';

const root = ReactDOM.createRoot(document.getElementById('root'));

function BootError({ message }) {
  return (
    <div className="p-8 max-w-md text-ink">
      <h1 className="text-[18px] font-semibold tracking-tight text-ink m-0 mb-2">
        Couldn’t load saved data
      </h1>
      <p className="text-[13px] text-ink-muted m-0">{message}</p>
      <p className="text-[12px] text-ink-faint mt-3 mb-0">
        Check that Redis is up and the app can reach the store.
      </p>
    </div>
  );
}

window.addEventListener('beforeunload', () => {
  // Best-effort sync; browser may cancel async — flush is also debounced during use.
  flushStore().catch(() => {});
});

hydrateStore()
  .then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((err) => {
    root.render(<BootError message={err?.message || String(err)} />);
  });
